import { useManfredite, useManfrediteUpdate } from 'hooks/api/manfredite';
import { useI18n } from 'hooks/useI18n';
import { useToasts } from 'hooks/useToasts';
import { useCallback, useState } from 'react';
import { getErrorMessage } from 'utils/errors';
import { UseJoinUsLoggedInModal } from './JoinUsLoggedInModal.types';

export const useJoinUsLoggedInModal: UseJoinUsLoggedInModal = ({ onClose }) => {
  const { t } = useI18n('join-us');
  const { manfredite } = useManfredite();
  const { updateManfrediteFromModel } = useManfrediteUpdate();
  const [isApplying, setIsApplying] = useState(false);
  const { addErrorToast, addSuccessToast } = useToasts();

  const onApplyClick = useCallback(async () => {
    if (!manfredite) return;

    setIsApplying(true);

    await updateManfrediteFromModel(
      manfredite,
      {
        isInterestedOnWorkAtManfred: true
      },
      {
        onSuccess: () => {
          addSuccessToast(t('modal.messages.success.apply'));
          setIsApplying(false);
          onClose();
        },

        onError: (ex) => {
          console.error(
            `[JoinUsLoggedInModal] Could not apply to Work at Manfred. Exception: ${ex}`
          );

          addErrorToast(
            t('modal.messages.error.apply.desc', {
              error: getErrorMessage(ex)
            }),
            t('modal.messages.error.apply.title')
          );
          setIsApplying(false);
        }
      }
    );
  }, [
    addErrorToast,
    addSuccessToast,
    manfredite,
    onClose,
    t,
    updateManfrediteFromModel
  ]);

  return {
    t,
    isApplying,
    onApplyClick
  };
};
